export interface ProductReview {
  id: string;
  beverageId: string;
  userName: string;
  avatar: string;
  rating: number;
  title: string;
  comment: string;
  date: string;
  verified: boolean;
  helpful: number;
}

export const productReviews: ProductReview[] = [];
